import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { vuetifyOptions } from '/src/common/config/vuetify.options';

export default defineNuxtPlugin({
  name: 'vuetify-plugin',
  enforce: 'pre',
  setup(nuxtApp) {
    // Every component is registered globally because runtime-compiled templates
    // (html widgets, object templates) may reference any of them.
    const options = { ...vuetifyOptions, components, directives };
    const vuetify = createVuetify(options);
    window.vuetifyOptions = { ...options };
    nuxtApp.vueApp.use(vuetify, {
      customProperties: true
    });

    // Keep backward compatibility without overriding Vuetify's own customProperties payload.
    const compatVuetify = nuxtApp.vueApp.config.globalProperties.$vuetify || vuetify;

    return {
      provide: {
        vuetify: compatVuetify
      }
    };
  }
});
